import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";
// import "flatpickr/dist/flatpickr.min.css";

export default class extends Controller {
  connect() {
    // console.log("Flatpickr connected");
    flatpickr(this.element, {
      enableTime: true,      // Enables time selection
      dateFormat: "Y-m-d H:i", // Formats as YYYY-MM-DD HH:MM
      time_24hr: true,       // Use 24-hour format (set to false for 12-hour AM/PM)
      minuteIncrement: 5,    // Set minute selection step (e.g., every 5 minutes)
      defaultHour: 12,       // Default to 12:00 PM
      defaultMinute: 0       // Default to 00 minutes
    });
  }
}
